import Cookies from 'js-cookie'
import store from '@/store'

export function checkPermission(action){
   const permissions = store.getters.permission
   return permissions.includes(action)
}

const ManagerToken = 'token'

export function getToken() {
  return Cookies.get(ManagerToken)
}

export function setToken(token) {
  return Cookies.set(ManagerToken, token, { expires: 7 })
}

export function removeToken() {
  return Cookies.remove(ManagerToken)
}

const ManagerName = 'manager-name'

const ManagerId = 'manager-id'

const ManagerAvatar = 'manager-avatar'

const ManagerRole = 'manager-role'

const ManagerDepartId = 'depart-id'

export function getManager() {
  const role = JSON.parse(Cookies.get(ManagerRole))
  return {
    id: Cookies.get(ManagerId),
    name: Cookies.get(ManagerName),
    avatar: Cookies.get(ManagerAvatar),
    departId: Cookies.get(ManagerDepartId),
    role: role,
  }
}

export function setManager(manager) {
  return {
    id: Cookies.set(ManagerId, manager.id, {expires: 7}),
    name: Cookies.set(ManagerName, manager.name, {expires: 7}),
    avatar: Cookies.set(ManagerAvatar, manager.avatar ? manager.avatar : '', {expires: 7}),
    departId: Cookies.set(ManagerDepartId, manager.departId ? manager.departId : '', {expires: 7}),
    role: Cookies.set(ManagerRole, manager.role, {expires: 7})
  }
}

export function removeManager() {
   Cookies.remove(ManagerId) 
   Cookies.remove(ManagerName) 
   Cookies.remove(ManagerAvatar)
   Cookies.remove(ManagerRole)
   Cookies.remove(ManagerDepartId)
   return true
}



// WEBPACK FOOTER //
// ./src/utils/Auth.js